import { FC } from 'react';
import { ISourceDataStore } from '@stores/sourceDataStore';
import sourceFactory from '@components/sources/sourceFactory';
import { SourceConfig } from '@stores/source';

interface OwnProps {
  source: ISourceDataStore;
  onChange: (value: SourceConfig, isValid: boolean) => void;
}

type Props = OwnProps;

const ConfigurationEdit: FC<Props> = (props: Props) => {
  const { source, onChange } = props;
  const { sourceDef } = source;
  return sourceFactory(sourceDef.category).getConfigurationComponent({
    source,
    onChange,
  });
};

export default ConfigurationEdit;
